import { useTranslation } from 'react-i18next';

export function useTagLabel() {
  const { t } = useTranslation('eos');
  return (value: string): string => {
    if (value === 'energy') return t('energy');
    if (value === 'electricity') return t('electricity');
    if (value === 'districtHeating') return t('districtHeating');
    if (value === 'forecast') return t('forecast');
    if (value === 'temperatureOut') return t('temperatureOut');
    if (value === 'energyPrice') return t('energyPrice');
    return value;
  };
}
